const colors = {
  white: "#ffffff",
  softWhite: "#F5F5F5",
  whiteSmoke: "#EAEAEA",

  gray: "#999999",
  lightGray: "#F6F6F6",
  softGray: "#F7F7F7",
  darkGray: "#0c0c0c",

  black: "#000000", //"#303036",
  blackCarbon: "#14161a",
  yellow: "#EAEF22",
  orange: "#ff8200",
  purple: "#6e07f3",
  green: "#70db05",
  lightBlue: "#0086ff",
  blue: "#0168FA",

  red: "#E00000",

  //Cores dos gráficos
  adobeXdColor: "#ff0096",
  javaScriptColor: "#ffe400",
  htmlColor: "#ff8200",
  typeScriptColor: "#0092ff",
  cssColor: "#00c3ff",
  nodeJsColor: "#00ff22",
  sintaxeJsxColor: "#0b5394",
  reactColor: "#0086ff",
  ReactTestingLibrary: "#ff9f9f",

  //pegar cores totais e mesclar aqui
  darkOpacity: "#00000020",
};

export default colors;
